export const Modal = ({ children, onClose, isLg = false, showHeader=true, title = '' }) => {

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block", backdropFilter: 'blur(5px)', background: 'rgb(0 0 0 / 59%)' }}>
            <div className={`modal-dialog ${isLg && 'modal-lg'}`}>
                <div className="modal-content">
                    {showHeader &&
                        <div className="modal-header headcolor">
                            <h5 className="modal-title" >{title}</h5>
                            <button onClick={onClose} type="button" className="btn-close" ></button>
                        </div>}
                    <div className="modal-body">

                        {children}

                    </div>
                </div>
            </div>
        </div>
    );

}